import { render, staticRenderFns } from "./be-svg.vue?vue&type=template&id=443ed362"
import script from "./be-svg.vue?vue&type=script&lang=js"
export * from "./be-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports